export default __webpack_public_path__ + "static/media/laurels.41703c4e.png";